import axios from "axios"
import { GET_FOOTER, GET_MAIN_PAGE, GET_NAVBAR, GET_PATHS_PRODUCT_TYPES, GET_PATHS_PRODUCTS, GET_PRODUCT, GET_PRODUCT_TYPE } from "../utils/endpoints/ContentEndPoints"

export const getNavBar = () => axios.get(GET_NAVBAR);
export const getFooter = () => axios.get(GET_FOOTER);
export const getMainPage = () => axios.get(GET_MAIN_PAGE);

export const getProductType = (productType: string) => axios.get(GET_PRODUCT_TYPE(productType));
export const getPathsProductTypes = () => axios.get(GET_PATHS_PRODUCT_TYPES);

export const getProduct = (product: string) => axios.get(GET_PRODUCT(product));
export const getPathsProducts = () => axios.get(GET_PATHS_PRODUCTS);